import { Link } from "react-router-dom";
import { prepareTags } from "../utils/commonUtility";

export default function RelatedBlogItem ({blog}) {
    const { id, image, title, tags, createdAt } = blog || {};

    const tagList = prepareTags(tags);

    return (
        <div className="card">
            <Link to={`/blogs/${id}`}>
                <img
                    src={image}
                    className="card-image"
                    alt=""
                />
            </Link>
            <div className="p-4">
                <Link 
                    to={`/blogs/${id}`}
                    className="text-lg post-title lws-RelatedPostTitle"
                >
                    {title}
                </Link>
                <div className="mb-0 tags">
                    {tagList}
                </div>
                <p>{createdAt}</p>
            </div>
        </div>
    );
}